import { useQuery } from "@tanstack/react-query";
import type { CalculatorIconType } from "shared/CalculatorIcons";
import { CalculatorKeys } from "web_myplann/Api/Calculators/CalculatorKeys";
import { getCalculatorAccess } from "web_myplann/Infrastructure/ApiOld/Api";

export const useGetDashboardPermissionsQuery = () => {
	return useQuery({
		queryKey: CalculatorKeys.dashboardPermissions(),
		queryFn: () => getCalculatorAccess(),
		select: (resp) => {
			const items = resp?.status === 200 ? (resp.data?.data?.items ?? []) : [];
			const hasAccess = (type: CalculatorIconType) =>
				items.find((item) => String(item.calculatorType) === type)?.access ??
				false;

			return {
				mortgage: hasAccess("mortgage"),
				travelInsurance: hasAccess("travelInsurance"),
				propertyInsurance: hasAccess("propertyInsurance"),
				carMotoInsurance: hasAccess("carMotoInsurance"),
				consumerLoan: hasAccess("consumerLoan"),
				pensionAnnuity: hasAccess("pensionAnnuity"),
			} satisfies Record<CalculatorIconType, boolean>;
		},
	});
};
